export enum EventPrinterStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

export enum EventStatusEnum {
  Archived = 'ARCHIVED',
  Active = 'ACTIVE',
}

export enum EventAiModelType {
  Nike = 'NIKE',
  StableDiffusion = 'STABLE_DIFFUSION',
}

export enum EventModelPosition {
  FrontSM = 'FRONT_SMALL',
  FrontLG = 'FRONT',
  Back = 'BACK',
}

export enum EventParticipantStatus {
  Unconfirmed = 'UNCONFIRMED',
  Confirmed = 'CONFIRMED',
  CheckedIn = 'CHECKED_IN',
}

//delete
export enum EventTabsType {
  Models = 'models',
  Styles = 'styles',
  Masks = 'masks',
  Printers = 'printers',
  Inventory = 'inventory',
  Participants = 'participants',
}

export enum EventDetailsTab {
  Info = 'info',
  AIConfiguration = 'aiModel',
  Video = 'video',
  Models = 'models',
  Styles = 'styles',
  Masks = 'masks',
  Printers = 'printers',
  Participants = 'participants',
  Inventory = 'inventory',
  OrdersHistory = 'orderHistory',
  SMSHistory = 'smsHistory',
}

export enum EventType {
  OneOfOne = 'OneOfOne',
  ProductPickup = 'productPickup',
  CheckInApp = 'checkInApp',
  AppointmentBooker = 'appointmentBooker',
}

export const eventStatusOptions = [
  { value: EventStatusEnum.Active.toLowerCase(), id: EventStatusEnum.Active },
  {
    value: EventStatusEnum.Archived.toLowerCase(),
    id: EventStatusEnum.Archived,
  },
];

export const positionOptions = [
  { value: EventModelPosition.FrontSM, id: 'Front Small' },
  { value: EventModelPosition.FrontLG, id: 'Front Large' },
  { value: EventModelPosition.Back, id: 'Back' },
];

export const participantStatusOptions = [
  {
    value: 'Unconfirmed',
    id: EventParticipantStatus.Unconfirmed,
  },
  {
    value: 'Confirmed',
    id: EventParticipantStatus.Confirmed,
  },
  {
    value: 'Checked in',
    id: EventParticipantStatus.CheckedIn,
  },
];

export const eventAiOptions = [
  { value: 'Nike', id: EventAiModelType.Nike },
  {
    value: 'Stable Diffusion',
    id: EventAiModelType.StableDiffusion,
  },
];

export enum InventoryReportType {
  CheckedOutBags = 'bags-checked-out',
  BackStockInventory = 'current-stock',
}

export const maxVideoPreviewSize = 100 * 1024 * 1024;

export const secretKeysOptions = [
  {
    label: 'iOS key',
    formKey: 'iosSecretKey',
  },
  {
    label: 'Desktop key',
    formKey: 'desktopSecretKey',
  },
];

export const EVENT_DETAILS_HISTORY_TABS = [
  EventDetailsTab.OrdersHistory,
  EventDetailsTab.SMSHistory,
];

export const EVENT_DETAILS_TABLE_TABS = [
  EventDetailsTab.Models,
  EventDetailsTab.Styles,
  EventDetailsTab.Masks,
  EventDetailsTab.Printers,
  EventDetailsTab.Participants,
  EventDetailsTab.Inventory,
  EventDetailsTab.OrdersHistory,
  EventDetailsTab.SMSHistory,
];
